import React, { Fragment, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ADD_TASK } from "../Constants/reducerEvents";
import QuizSharpIcon from "@mui/icons-material/QuizSharp";
import AssignmentSharpIcon from "@mui/icons-material/AssignmentSharp";
import {
  Card,
  CardContent,
  IconButton,
  Popover,
  Typography,
} from "@mui/material";
import { makeStyles } from "@material-ui/core/styles";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import moment from "moment";
import { getContrastYIQ } from "../Utils/color.utils";
import { getTypeIcon } from "../Utils/utils";
const useStyles = makeStyles((theme) => ({
  popover: {
    pointerEvents: "none",
  },
  popoverContent: {
    pointerEvents: "auto",
  },
}));

export default function TaskPreviewDot({ task, onClick }) {
  const [openedPopover, setOpenedPopover] = useState(false);
  const courseName = useSelector((state) =>
    state.courses.find((c) => c.id === task.courseId)
  )?.name;
  const courseColor = useSelector((state) =>
    state.courses.find((c) => c.id === task.courseId)
  )?.color;
  const dispatch = useDispatch();
  const popoverAnchor = useRef(null);

  const classes = useStyles();

  const popoverEnter = ({ currentTarget }) => {
    setOpenedPopover(true);
  };

  const popoverLeave = ({ currentTarget }) => {
    setOpenedPopover(false);
  };

  const clicked = () => {
    onClick(task);
  };
  const getBorderColor = () => {
    if (!task.type) {
      return task.isTest ? "#ffda21" : "#195ac2";
    }
    switch (task.type) {
      case "EVENT":
        return "#457b3b";
      case "ASSIGNMENT":
        return "#3873cb";
      case "EXAM":
        return "red";
      case "QUIZ":
        return "#9031aa";
    }
  };
  const getBackgroundColor = () => {
    return courseColor ? courseColor : "#eeeeee";
  };

  return (
    <div>
      <div
        style={{
          width: "10px",
          height: "10px",
          display: "flex",
          margin: "3px",
          borderStyle: "solid",
          borderWidth: "2px",
          borderColor: getBorderColor(),
          borderRadius: "50%",
          backgroundColor: getBackgroundColor(),
          cursor: "pointer",
        }}
        ref={popoverAnchor}
        aria-owns="mouse-over-popover"
        aria-haspopup="true"
        onMouseEnter={popoverEnter}
        onMouseLeave={popoverLeave}
        onClick={() => clicked()}
      ></div>
      <Popover
        id="mouse-over-popover"
        className={classes.popover}
        classes={{
          paper: classes.popoverContent,
        }}
        open={openedPopover}
        anchorEl={popoverAnchor.current}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        // PaperProps={{ onMouseEnter: popoverEnter, onMouseLeave: popoverLeave }}
      >
        <div style={{ display: "flex" }}>
          {!task.type ? (
            <IconButton size="small" disabled>
              {task.isTest && <QuizSharpIcon color="secondary" />}
              {!task.isTest && <AssignmentSharpIcon color="primary" />}
            </IconButton>
          ) : (
            <IconButton size="small" disabled>
              {getTypeIcon(task.type)}
            </IconButton>
          )}
          <div style={{ paddingTop: "5px", paddingRight: "5px" }}>
            {courseName ? `${courseName}` : ""}
          </div>
        </div>
        {/* <IconButton size="small" onClick={clicked}>
          <EditOutlinedIcon color="disabled" />
        </IconButton>
        <IconButton size="small" onClick={togglePinned}>
          <PriorityHighIcon color={task.pinned ? "error" : "disabled"} />
        </IconButton>
        <IconButton size="small" onClick={setComplete}>
          <CheckCircleOutlineOutlinedIcon color="success" />
        </IconButton> */}

        <Typography sx={{ p: 1, maxWidth: "400px" }}>
          {`${task.name}`}
        </Typography>
        {task.description.length > 0 && (
          <Typography sx={{ p: 1, maxWidth: "400px" }}>
            {task.description}
          </Typography>
        )}
      </Popover>
    </div>
  );
}
